import SectionLabel from '@/pages/home/components/SectionLabel';
import { columnEntries } from '@/mocks/homeData';

export default function ColumnEntrances() {
  return (
    <section id="columns" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionLabel
          index="01"
          kicker="COLUMNS · 栏目目录"
          title="按专题找事件，入口都排在这一排"
          desc="黑料六点固定栏目的四个主入口：今天、目录、归档与投稿。想追一个完整事件，顺着目录找对应专题就行。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {columnEntries.map((entry) => (
            <a
              key={entry.title}
              href={entry.href}
              className={
                entry.primary
                  ? 'group flex flex-col justify-between rounded-lg border border-primary-500 bg-primary-500 p-5 text-background-50 transition-colors hover:bg-primary-600'
                  : 'group flex flex-col justify-between rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200 hover:bg-background-50'
              }
            >
              <div>
                <span
                  className={
                    entry.primary
                      ? 'flex h-11 w-11 items-center justify-center rounded-md bg-primary-600 text-xl'
                      : 'flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-xl text-primary-600'
                  }
                >
                  <i className={entry.icon} />
                </span>
                <h3
                  className={
                    entry.primary
                      ? 'mt-4 font-heading text-lg font-bold'
                      : 'mt-4 font-heading text-lg font-bold text-foreground-950'
                  }
                >
                  {entry.title}
                </h3>
                <p className={entry.primary ? 'mt-2 text-sm text-background-100/90' : 'mt-2 text-sm text-foreground-600'}>
                  {entry.desc}
                </p>
              </div>
              <span
                className={
                  entry.primary
                    ? 'mt-6 flex items-center gap-1.5 text-sm font-medium'
                    : 'mt-6 flex items-center gap-1.5 text-sm font-medium text-primary-600'
                }
              >
                {entry.action}
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}